<template>
    <div class="basicDetails">
        <div class="form-group">
            <label>Alias URL:</label>
            <div class="d-flex aliasURL">
                <span class="w-50 alias">https://app.smartcard.womi.ma/S/</span>
                <input type="text" class="form-control w-50" v-model="urlName" disabled><i class="fa-solid fa-eye" @click="templatePage"></i>
            </div>
        </div>

        <div class="rowInputs">
            <div class="form-group">
                <label>Virtual card name:</label>
                <div>
                    <input type="text" class="form-control" v-model="name">
                </div>
            </div>
            <div class="form-group">
                <label>Occupation:</label>
                <div>
                    <input type="text" class="form-control" v-model="currentPost">
                </div>
            </div>
        </div>

        <div class="rowInputs">
            <div class="form-group">
                <label>description:</label>
                <div>
                    <!-- <input type="text" class="form-control" v-model="description"> -->
                    <textarea type="text" class="form-control" v-model="description" rows="5"></textarea>
                </div>
            </div>
            <div class="form-group cardIcons">
                <div class="cardIcon">
                    <label>Profile Picture:</label>
                    <div class="input_items">
                        <input
                        type="file"
                        accept="image/*"
                        class="form-control hide-file-input"
                        id="file-input"
                        @change="setImageProfile">

                        <label class="file-label" for="file-input"> 
                            <i class="fa-solid fa-question question_icon" v-if="!profile_img_url"></i>
                            <img :src="profile_img_url" alt="" v-if="profile_img_url" class="selectedIMG">
                        </label>
                            <i class="fa-solid fa-circle-xmark close_icon" v-if="profile_img_url" @click="deleteSelectedImg('profile')"></i>
                    </div>
                </div>
                <div class="cardIcon">
                    <label>Background image:</label>
                    <div class="input_items">
                        <input
                        type="file"
                        accept="image/*"
                        class="form-control hide-file-input"
                        id="file-input_2"
                        @change="setImageBackground">

                        <label class="file-label" for="file-input_2"> 
                            <i class="fa-solid fa-question question_icon" v-if="!background_img_url"></i>
                            <img :src="background_img_url" alt="" v-if="background_img_url" class="selectedIMG">
                        </label>
                            <i class="fa-solid fa-circle-xmark close_icon" v-if="background_img_url" @click="deleteSelectedImg('background')"></i>
                    </div>
                </div>
            </div>
        </div>

        <h4>VCard Details</h4>

        <div class="rowInputs">
            <div class="form-group">
                <label>First name:</label>
                <div>
                    <input type="text" class="form-control" v-model="details.firstName">
                </div>
            </div>
            <div class="form-group">
                <label>Last name:</label>
                <div>
                    <input type="text" class="form-control" v-model="details.lastName">
                </div>
            </div>
        </div>

        <div class="rowInputs">
            <div class="form-group">
                <label>E-mail:</label>
                <div>
                    <input type="text" class="form-control" v-model="details.email">
                </div>
            </div>
            <div class="form-group">
                <label>Phone:</label>
                <div>
                    <input type="text" class="form-control" v-model="details.phone">
                </div>
            </div>
        </div>

        <div class="rowInputs">
            <div class="form-group">
                <label>Location:</label>
                <div>
                    <input type="text" class="form-control" v-model="details.place">
                </div>
            </div>
            <div class="form-group">
                <label>Location URL:</label>
                <div>
                    <input type="text" class="form-control" v-model="details.placeUrl.url">
                </div>
            </div>
        </div>

        <div class="rowInputs">
            <div class="form-group">
                <label>Date of Birth:</label>
                <div>
                    <input type="text" class="form-control" v-model="details.birthdayDay">
                </div>
            </div>
            <div class="form-group">
                <label>Company:</label>
                <div>
                    <input type="text" class="form-control" v-model="details.company">
                </div>
            </div>
        </div>

        <div class="rowInputs">
            <div class="form-group">
                <label>Job title:</label>
                <div>
                    <input type="text" class="form-control" v-model="details.jobTitle">
                </div>
            </div>
            <div class="form-group">
                <label>Default language:</label>
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="details.defaultLanguage"
              >
                <option selected>English</option>
                <option>Arabic</option>
                <!-- <option v-for="(hour, index) in hours" :key="index">
                  {{ hour }}
                </option> -->
              </select>
            </div>
        </div>

        <button type="submit" class="btn btn-light me-2" @click="updateCardBasicDetails" v-if="!activeSpinner">Save</button>

        <div class="spinner-grow" role="status" v-if="activeSpinner">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import APIs from './../../../../config'
    export default {
        data(){
            return {
                urlName: "",
                name : "",
                currentPost: "",
                description: "",
                profileImg: null,
                backgroundImg: null,

                profile_img_url: null,
                background_img_url: null,
                details: {
                    firstName: "",
                    lastName: "",
                    email: "",
                    phone: "",
                    place: "",
                    placeUrl: {
                        url: "",
                        lat: "",
                        lon: ""
                    },
                    birthdayDay: "",
                    company: "",
                    jobTitle: "",
                    defaultLanguage: "English",
                },
                get_token: localStorage.getItem('admin_token'),
                user_id: localStorage.getItem('admin_id'),
 
                activeSpinner: false
            }
        },
        props : {
            cardInfo : Object
        },
        async created() {
            this.activeSpinner = true
            // console.log("basic details: ", this.cardInfo._id)
            await this.getCurrentData()
            this.activeSpinner = false
        },
        methods: {
            templatePage() { 
                window.open(`${APIs.API_LOCALHOST}/S/${this.urlName}`, '_blank')
            },
            setImageProfile(event){
                this.profileImg = event.target.files[0]
                if(this.profileImg)
                    this.profile_img_url = URL.createObjectURL(this.profileImg)
                else
                    this.profile_img_url = null
            },
            setImageBackground(event){
                this.backgroundImg = event.target.files[0]

                if(this.backgroundImg)
                    this.background_img_url = URL.createObjectURL(this.backgroundImg)
                else
                    this.background_img_url = null
            },
            deleteSelectedImg(selected) {
                if(selected == "profile") {
                    this.profileImg = null
                    this.profile_img_url = null
                }
                if(selected == "background") {
                    this.backgroundImg = null
                    this.background_img_url = null
                }
            },
            updateCardBasicDetails() {
                this.activeSpinner = true
                let formData1 = {
                    name: this.name,
                    currentPost: this.currentPost,
                    description: this.description,
                    details: this.details
                }

                let formData2 = new FormData()
                formData2.append('profileImg', this.profileImg)
                formData2.append('backgroundImg', this.backgroundImg)

                const reqOne = axios.put(`${APIs.API_URL}/card/admin/cardData/${this.user_id}/${this.cardInfo._id}`, formData1, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${this.get_token}`
                    }
                });
                const reqTwo = axios.put(`${APIs.API_URL}/card/admin/cardDataImg/${this.user_id}/${this.cardInfo._id}`, formData2, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${this.get_token}`
                    }
                });

                axios.all([reqOne, reqTwo]).then(axios.spread((...responses) => {
                    console.log(responses[0])
                    this.activeSpinner = false
                    this.$swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: "Edited",
                        showConfirmButton: false,
                        timer: 1500
                    });
                })).catch(error => {
                    this.activeSpinner = false
                    this.$swal.fire({
                        position: 'top-end',
                        icon: 'error',
                        title: error.response.data.error,
                        showConfirmButton: false,
                        timer: 1500
                    });
                })
            },
            getCurrentData() {
                this.details = this.cardInfo.details
                this.name = this.cardInfo.name
                this.currentPost = this.cardInfo.currentPost
                this.description = this.cardInfo.description
                this.urlName = this.cardInfo.generatedUrl

                // http://localhost:3001/api/card/cardDataImg/63ac5f8c37328f344c174aa4/63aceef259b6722c048c0125
                axios.get(`${APIs.API_URL}/card/admin/cardDataImg/${this.user_id}/${this.cardInfo._id}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${this.get_token}`
                    }
                })
                .then(async res => {
                    if(res.data.profileImg == "" && res.data.backgroundImg == "")
                        return this.activeSpinner = false

                    // console.log("response", res.data.profileImg)
                    // console.log("response", res.data.backgroundImg)

                    const url = APIs.API_IMAGES + "/" + res.data.profileImg
                    const url2 = APIs.API_IMAGES + "/" + res.data.backgroundImg
                    const fileName = 'myFile.jpg'

                    await fetch(url)
                    .then(async response => {
                        const contentType = response.headers.get('content-type')
                        const blob = await response.blob()
                        const file = new File([blob], fileName, { contentType, type: "image/jpeg" })
                        // access file here
                        if(file) {
                            this.profileImg = file
                            this.profile_img_url = URL.createObjectURL(this.profileImg)
                        }
                    })

                    await fetch(url2)
                    .then(async response => {
                        const contentType = response.headers.get('content-type')
                        const blob = await response.blob()
                        const file = new File([blob], fileName, { contentType, type: "image/jpeg" })
                        // access file here
                        if(file) {
                            this.backgroundImg = file
                            this.background_img_url = URL.createObjectURL(this.backgroundImg)
                        }
                    })
                })

                // console.log("Genarated profile img", this.profileImg)
                // console.log("Genarated background img", this.backgroundImg)
            }
        }
    }
</script>

<style scoped lang="scss">
    .basicDetails {
        background-color: white;
        padding: 2% 6%;
        border-radius: 10px;
        margin: 0% 5%;

        .hide-file-input {
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            margin: -1px;
            overflow: hidden;
            clip: rect(0, 0, 0, 0);
            white-space: nowrap;
            border-width: 0;
        }
        .file-label {
            position: relative;

            .question_icon {
                font-size: 40px;
                cursor: pointer;
                margin-left: 40px;
                color: #00468B;
            }
            img {
                cursor: pointer;
            }
        }

        .rowInputs {
            display: flex;
            justify-content: space-around;
            .form-group {
                width: 45%;
            }
            .cardIcons {
                display: flex;
                justify-content: space-between;
                .cardIcon {
                    width: 45%;
                    .input_items {
                        position: relative;
                        .close_icon {
                            position: absolute;
                            font-size: 30px;
                            cursor: pointer;
                            color: red;
                            z-index: 1;
                            top: 0;
                            right: 0;
                        }
                    }
                    .selectedIMG {
                        width: 90%;
                        border-radius: 20px;
                    }
                }
            }
        }

        .aliasURL {
            .alias {
                background-color: #e9ecef;
                color: gray;
                font-weight: bold;
                padding: 1%;
                border-radius: 10px;
                margin-right: 2%;
                text-align: center;
            }
            i {
                color: #00468B;
                margin: 1%;
                cursor: pointer;
                font-size: 20px;
            }
        }
    }
</style>
